import type { Answer } from './GameCollectionShelfPhoto'
import type { ShelfRowData } from './GameCollectionShelfRow'
import { GameCollectionShelfRow } from './GameCollectionShelfRow'

type Props = {
  shelfRowImageTemplate?: string
  shelfRowImageUrl?: string
  badgeBgColor?: string
  badgeTextColor?: string
  columnCount?: number
  shelfData: ShelfRowData[]
  handleShelfPhotoClick: (answer: Answer) => void
}

export function GameCollectionShelf(props: Props) {
  const { shelfRowImageTemplate, shelfRowImageUrl, badgeBgColor, badgeTextColor, columnCount, shelfData, handleShelfPhotoClick } = props

  return (
      <div className="flex size-full flex-col gap-5 overflow-y-auto overflow-x-hidden pb-5 pl-4">
        {shelfData.map(shelfRowData => (
          <GameCollectionShelfRow
            key={shelfRowData.campaignId}
            shelfRowImageTemplate={shelfRowImageTemplate}
            shelfRowImageUrl={shelfRowImageUrl}
            badgeBgColor={badgeBgColor}
            badgeTextColor={badgeTextColor}
            columnCount={columnCount}
            shelfRowData={shelfRowData}
            handleShelfPhotoClick={handleShelfPhotoClick}
          />
        ))}
      </div>
  )
}
